import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useRoute } from 'vue-router'

/**
 * Отправка MQTT команд
 */
export const useSendMqtt = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()
  const route = useRoute()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      return http.post(`/cabinets/${route.params.object_id}/admin/services/mqtt`, data)
    },
  })

  const sendForm = async (data: any, valid: boolean) => {
    if (!valid) return

    try {
      await mutation.mutateAsync(data)

      addSuccess(trs('itf.command_send'))
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    sendForm,
  }
}

/**
 * Изменение правил переключения
 */
export const useSendSwitching = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()
  const route = useRoute()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      return http.put(`/cabinets/${route.params.object_id}/admin/services/switching`, data)
    },
  })

  const sendForm = async (data: any, valid: boolean) => {
    if (!valid) return

    try {
      await mutation.mutateAsync(data)

      addSuccess(trs('itf.config_save'))

      await queryClient.fetchQuery({ queryKey: ['load_cabinet', route.params.object_id] })
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    sendForm,
  }
}
